import { TAdditionalInformationFormValues, TPepEntity, TRelatedPep } from './types';
import { ClientTypes } from '~/constants/clientTypes.ts';

export const defaultPepInfo: TRelatedPep = {
  fullName: null,
  identificationNumber: null,
  foreignTaxNumber: null,
  citizenshipCountry: { value: '804', label: 'Україна' },
  residenceCountry: { value: '804', label: 'Україна' },
  pepPosition: null,
  publicFunctionsStartDate: null,
  publicFunctionsEndDate: null,
};

export const emptyPep: TPepEntity = {
  fullName: '',
  pepInfo: null,
  familyPepsInfo: null,
  pepRelatedPersonsInfo: null,
  isPepsAbsent: false,
  isPep: false,
  isFamilyPep: false,
  isPepRelatedPerson: false,
  hasForeignTaxResidency: false,
  lastName: '',
  firstName: '',
  middleName: '',
  appeals: null,
  jurisdictions: null,
  accounts: null,
};

export enum PepSection {
  pepInfo = 'pepInfo',
  familyPepsInfo = 'familyPepsInfo',
  pepRelatedPersonsInfo = 'pepRelatedPersonsInfo',
}

export const IDENTIFICATION_NUMBER_LENGTH = 10;
export const FOREIGN_TAX_NUMBER_LENGTH = 15;
export const MAX_INPUT_LENGTH = 120;

export const typeAppeals = [
  { value: 'MR', label: 'Mr' },
  { value: 'DR', label: 'Dr' },
  { value: 'MS', label: 'Ms' },
  { value: 'HERR', label: 'Herr' },
];

export const reasonsIdentificationNumber = [
  {
    value: 'A',
    label:
      'Держава/юрисдикція, резидентом якої є Власник Рахунку, не видає номер платника податків своїм резидентам',
  },
  {
    value: 'B',
    label:
      'Власник Рахунку не може отримати номер платника податків або еквівалентний номер з інших причин (будь  ласка, ОБОВ’ЯЗКОВО вкажіть причину чому Ви не можете отримати)',
  },
  {
    value: 'C',
    label:
      'номер платника податків не вимагається (ОБОВ’ЯЗКОВО зазначте цю причину, тільки в тому  випадку, якщо національне законодавство відповідної юрисдикції не вимагає  збір номер платника податків, виданих цією юрисдикцією)',
  },
];

export const infoAccountTableColumns = [
  {
    title: 'Номер рахунку',
    size: 6,
  },
  {
    title: 'Дата відкриття рахунку',
    size: 5,
  },
];

export const JURISDICTION = {
  country: null,
  identifyCode: null,
  reason: null,
  explanation: null,
};

export const ACCOUNT = {
  iban: null,
  openDate: null,
};

export enum FATCA_TIN {
  SSN = 'SSN',
  ITIN = 'ITIN',
  TIN = 'TIN',
}

export enum REFUTATION_DOC_TYPE {
  DS_4083 = 'DS_4083',
  I_407 = 'I_407',
  EXPLANATION = 'EXPLANATION',
}

export const FatcaTinTypeOptions = [
  {
    value: FATCA_TIN.SSN,
    label: 'SSN (Social Security Number - номер соціального страхування США);',
  },
  {
    value: FATCA_TIN.ITIN,
    label: 'ITIN (Individual Taxpayer Identification Number - для осіб без SSN);',
  },
  {
    value: FATCA_TIN.TIN,
    label: 'TIN (Taxpayer Identification Number - інший, ніж SSN чи ITIN);',
  },
];

export const fatcaTin = [FATCA_TIN.SSN, FATCA_TIN.ITIN, FATCA_TIN.TIN];

export const refutationDocTypeOptions = [
  {
    value: REFUTATION_DOC_TYPE.DS_4083,
    label:
      'Копію свідоцтва про втрату громадянства США (форма DS 4083 Бюро консульських справ Державного департаменту США)',
  },
  {
    value: REFUTATION_DOC_TYPE.I_407,
    label: 'Копію Запису про відмову від законного статусу постійного жителя — форма І-407',
  },
  {
    value: REFUTATION_DOC_TYPE.EXPLANATION,
    label:
      'Письмові пояснення відносно відсутності громадянства США (наприклад, причина, з якої громадянство США не було отримано за правом народження)',
  },
];

export const testDataAdditionalInformationSoleTrader: TAdditionalInformationFormValues = {
  additionalInformation: [
    {
      type: ClientTypes.SOLE_TRADER,
      pepInfo: null,
      familyPepsInfo: null,
      pepRelatedPersonsInfo: null,
      jurisdictions: null,
      hasForeignTaxResidency: false,
      appeals: null,
      accounts: null,
      isPepsAbsent: true,
      isPep: false,
      isFamilyPep: false,
      isPepRelatedPerson: false,
      fullName: 'Тарас Григорович Шевченко',
    },
  ],
  fatca: {
    isForeignFinancialUnderFATCA: true,
    explanation: { usBirthAddress: null, message: null },
    tinType: 'SSN',
    tin: '153-32-8732',
    fullNameInEng: 'TARAS SHEVCHENKO',
    fullName: 'Тарас Григорович Шевченко',
    refutationDocType: null,
  },
};

export const testDataAdditionalInformationLegalResident: TAdditionalInformationFormValues = {
  additionalInformation: [
    {
      type: ClientTypes.LEGAL_RESIDENT,
      pepInfo: null,
      familyPepsInfo: null,
      pepRelatedPersonsInfo: null,
      fullName: 'Бондаренко Юлія Едуардівна',
      isPepsAbsent: true,
      isPep: false,
      isFamilyPep: false,
      isPepRelatedPerson: false,
      accounts: null,
    },
    {
      type: ClientTypes.LEGAL_RESIDENT,
      pepInfo: null,
      familyPepsInfo: [],
      pepRelatedPersonsInfo: [],
      fullName: 'БОНДАРЕНКО ІГОР ЕДУАРДОВИЧ',
      isPepsAbsent: true,
      isPep: false,
      isFamilyPep: false,
      isPepRelatedPerson: false,
      accounts: null,
    },
  ],
  fatca: {
    isForeignFinancialUnderFATCA: null,
    refutationDocType: null,
    explanation: { usBirthAddress: null, message: null },
    tinType: null,
    tin: null,
    fullName: null,
    fullNameInEng: null,
  },
};
